export default function UnsupportedHost({ name }) {
    return (
        <p>
            Your show is hosted on <b>{name}</b> which does not support third party measurement such
            as Podtrac. We recommend you send them a support request asking them to add support for
            Podtrac measurement.
        </p>
    );
}
